module.exports = fox._r("images/july4/gift-97.png", __webpack_public_path__ + "_/_/_/_/common/liveshow/images/july4/gift-97.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common/liveshow/images/july4/gift-97.png
// module id = 321
// module chunks = 4